export default {
  tabs: {
    home: 'Inicio',
    menu: 'Menú',
    orders: 'Pedidos',
  },
};
